/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
// Registro do service worker (PWA). Atualização ativada pelo usuário para evitar reload inesperado.

/* eslint-disable no-unused-vars */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

const version = process.env?.REACT_APP_VERSION;
let configWS: Config | undefined;

/** Evita agendar register/load mais de uma vez (StrictMode/HMR) */
let registrationScheduled = false;

/** Após applyServiceWorkerUpdate + skipWaiting, recarrega uma vez */
let pendingReloadAfterControllerChange = false;

let controllerChangeListenerAttached = false;

function attachControllerChangeListener(): void {
  if (controllerChangeListenerAttached || !('serviceWorker' in navigator)) {
    return;
  }
  controllerChangeListenerAttached = true;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (pendingReloadAfterControllerChange) {
      pendingReloadAfterControllerChange = false;
      window.location.reload();
      return;
    }
    forceSWupdate();
  });
}

function runWhenDocumentReady(callback: () => void): void {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

function forceSWupdate(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.update());
    }).catch(() => null);
  }
}

export function register(config?: Config): undefined {
  configWS = config;
  if (!('serviceWorker' in navigator)) {
    return undefined;
  }

  const publicUrl = new URL(
    process.env.PUBLIC_URL || '',
    window.location.href,
  );
  if (publicUrl.origin !== window.location.origin) {
    return undefined;
  }

  attachControllerChangeListener();

  if (!registrationScheduled) {
    registrationScheduled = true;
    runWhenDocumentReady(() => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js?v=${version}`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
        navigator.serviceWorker.ready.then(() => null).catch(() => null);
      } else {
        registerValidSW(swUrl);
      }
    });
  }

  return undefined;
}

function registerValidSW(swUrl: string): void {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') {
            return;
          }
          if (navigator.serviceWorker.controller) {
            // Nova versão em waiting: não chama skipWaiting aqui; usuário confirma em UpdateAvailable
            if (configWS?.onUpdate) {
              configWS.onUpdate(registration);
            }
          } else if (configWS?.onSuccess) {
            configWS.onSuccess(registration);
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl: string): void {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready
          .then((registration) => registration.unregister())
          .then(() => {
            forceSWupdate();
            window.location.reload();
          })
          .catch(() => null);
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => null);
}

/**
 * Chamado pelo botão "Atualizar" após nova versão disponível.
 * Ativa o worker em espera e recarrega na próxima troca de controller.
 */
export function applyServiceWorkerUpdate(): void {
  if (!('serviceWorker' in navigator)) {
    window.location.reload();
    return;
  }
  attachControllerChangeListener();
  pendingReloadAfterControllerChange = true;
  navigator.serviceWorker.getRegistration().then((registration) => {
    if (registration?.waiting) {
      registration.waiting.postMessage('SKIP_WAITING');
    } else {
      pendingReloadAfterControllerChange = false;
      window.location.reload();
    }
  }).catch(() => null);
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => {
        console.error(error.message);
      });
  }
}
